import React, { useEffect, useState } from "react";
import "./manageImage.css";
import NavBar from "../../components/bar/navBar";
import { app } from "../../components/firebase/firebase";
import "firebase/compat/storage";
import Notification from "../../components/notification";
import AudioSource from "../../assets/sound/check.mp3";

// icons
import { RiSearchLine } from "react-icons/ri";
import ButtonComponent from "../../components/button";
import { doc, increment, updateDoc } from "firebase/firestore";

function ManageImage() {
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(1);
  const [number, setNumber] = useState(0);
  const [count, setCount] = useState(0);

  const [lastDoc, setLastDoc] = useState(null);

  const [loading, setLoading] = useState("none");
  const [btnDelete, setBtnDelete] = useState("disabled");

  const [selected, setSelected] = useState([]);

  const [notification, setNotification] = useState(false);

  const [change, setChange] = useState(1);

  const db = app.firestore();

  function formatDate(timestamp) {
    const date = new Date(timestamp);

    // Récupérer le jour, le mois et l'année
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Les mois sont indexés à partir de 0
    const year = date.getFullYear();

    // Concaténer les éléments pour former la date au format "jj/mm/aaaa"
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  }

  useEffect(() => {
    db.collection("info")
      .doc("image")
      .get()
      .then(async (data) => {
        setNumber(data.data().number);
        setCount(data.data().count);
        const querySnapshot = await db
          .collection("image")
          .orderBy("index", "desc") // Tri par ordre croissant de la propriété "index"
          .limit(40)
          .get();

        setLastDoc(querySnapshot.docs[querySnapshot.docs.length - 1]);

        const imagesData = querySnapshot.docs.map((doc) => doc.data()); // Extraction des données des documents

        // Triez le tableau d'imagesData dans l'ordre décroissant de la propriété "index"
        imagesData.sort((a, b) => b.index - a.index);

        setImages(imagesData); // Mettez à jour le state avec le tableau trié des images
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
      });
  }, [change, db]);

  const handleClick = async () => {
    setLoading("loading");
    if (images.length < number) {
      const querySnapshot = await db
        .collection("image")
        .orderBy("index", "desc")
        .startAfter(lastDoc)
        .limit(40)
        .get();

      setLastDoc(querySnapshot.docs[querySnapshot.docs.length - 1]);
      const imagesData = querySnapshot.docs.map((doc) => doc.data()); // Extraction des données des documents

      // Triez le tableau d'imagesData dans l'ordre décroissant de la propriété "index"
      imagesData.sort((a, b) => b.index - a.index);

      setImages([...images, ...imagesData]); // Utilisez le spread operator (...) pour fusionner les tableaux
      setCurrent(current + 1);
      setLoading("none");
    } else {
      setLoading("none");
    }
  };

  const handleSelect = (id, event) => {
    console.log(event);
    const isSelected = selected.includes(id);
    let temp;

    if (isSelected) {
      temp = selected.filter((number) => number !== id);
    } else {
      temp = [...selected, id];
    }
    setSelected(temp);
    setBtnDelete(temp.length > 0 ? "none" : "disabled");
    const target = event.currentTarget;
    target.classList.toggle("active");
  };

  const handleDelete = () => {
    setBtnDelete("loading");
    var lenght = selected.length;
    var temp = images;
    selected.forEach(async (id, index) => {
      try {
        // Supprimer le document de la collection "image" dans Firestore
        await db.collection("image").doc(id.toString()).delete();

        // Supprimer le fichier correspondant dans Firebase Storage
        await app.storage().ref(`/images/${id}.jpg`).delete();
        document.getElementById(id).className = "";
        temp = temp.filter((item) => item.index !== id);
        if (index === lenght - 1) {
          await db
            .collection("info")
            .doc("image")
            .update({
              count: count - 1,
            });
          setBtnDelete("disabled");
          setSelected([]);
          setImages(temp);
          setNotification(true);
          const audio = new Audio(AudioSource); // Remplacez le chemin par le chemin vers votre fichier audio
          audio.play();
          setTimeout(() => {
            setNotification(false);
          }, 3000);
        }
      } catch (error) {
        console.error(
          `Erreur lors de la suppression du document ou du fichier avec l'ID ${id}:`,
          error
        );
        setBtnDelete("disabled");
      }
    });
  };

  const handleSearch = (value) => {
    clearAllSelections();
    if (value.length >= 3) {
      // Comptez le nombre de chiffres dans la chaîne de recherche
      const searchDigits = value.length;

      // Calcul de la valeur maximale de recherche en ajoutant 1 au dernier chiffre
      const maxValue = Number(value + "9".repeat(10 - searchDigits));

      // Effectuer la recherche dans la collection "maCollection" avec le champ "index" commençant par 104
      db.collection("image")
        .where("indexString", ">=", value)
        .where("indexString", "<=", maxValue.toString()) // Convertissez maxValue en chaîne de caractères pour la comparaison
        .get()
        .then((querySnapshot) => {
          const matchingDocuments = querySnapshot.docs.map((doc) => doc.data());
          matchingDocuments.sort((a, b) => b.index - a.index);
          setSelected([]);
          setBtnDelete("disabled");
          setImages(matchingDocuments);
        })
        .catch((error) => {
          console.error(
            "Erreur lors de la récupération des documents :",
            error
          );
        });
    } else {
      setChange(change + 1);
    }
  };
  const clearAllSelections = () => {
    for (const item of selected) {
      document.getElementById(item).className = "";
    }
  };

  const handleChange = (value, id, tag) => {
    db.collection("image")
      .doc(id.toString())
      .get()
      .then((data) => {
        var tags = data.data().tags;
        tags[tag] = value;
        db.collection("image")
          .doc(id.toString())
          .update({
            tags,
          })
          .then(() => {
            setNotification(true);
            const audio = new Audio(AudioSource); // Remplacez le chemin par le chemin vers votre fichier audio
            audio.play();
            setTimeout(() => {
              setNotification(false);
            }, 3000);
          });
      });
  };

  const handleKeyUp = (event, value, id, tag) => {
    if (event.key === "Enter") {
      handleChange(value, id, tag);
    }
  };

  return (
    <>
      <NavBar link="/" title="Administration" />
      <Notification state={notification} />
      <div className="ManageImage">
        <div className="header">
          <div className="title text-6xl">Modifier ou supprimer</div>
        </div>
        <div className="wrapper">
          <label htmlFor="search" className="ctn-search">
            <RiSearchLine className="icon" />
            <input
              type="search"
              name=""
              id="search"
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Rechercher par numéro d'image"
            />
          </label>
          <div className="result">
            <div className="top">
              <div className="left">{images.length} images</div>
              <div className="right">
                <ButtonComponent
                  text="Supprimer"
                  state={btnDelete}
                  color="red"
                  onClick={() => handleDelete()}
                />
              </div>
            </div>
            <div className="table">
              <table>
                <thead>
                  <th></th>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Tags</th>
                </thead>
                <tbody>
                  {images.map((data, index) => (
                    <tr
                      id={data.index}
                      onClick={(event) =>
                        handleSelect(parseInt(data.index), event)
                      }
                      key={index}
                    >
                      <td>
                        <div className="ctn-input">
                          <div className="check"></div>
                        </div>
                      </td>
                      <td>@DD{data.index}</td>
                      <td>{formatDate(data.date)}</td>
                      <td>
                        <select
                          onChange={(e) =>
                            handleChange(e.target.value, data.index, 0)
                          }
                          onClick={(event) => event.stopPropagation()}
                          defaultValue={data.tags[0]}
                        >
                          <option className="default-tag" value="">
                            Tag 1
                          </option>
                          <option value="Nuit">Nuit</option>
                          <option value="Coucher de soleil">
                            Coucher de soleil
                          </option>
                          <option value="Jours">Jours</option>
                          <option value="Levé du soleil">Levé du soleil</option>
                        </select>
                        <select
                          onChange={(e) =>
                            handleChange(e.target.value, data.index, 1)
                          }
                          onClick={(event) => event.stopPropagation()}
                          defaultValue={data.tags[1]}
                        >
                          <option className="default-tag" value="">
                            Tag 2
                          </option>
                          <option value="Montagne">Montagne</option>
                          <option value="Ville">Ville</option>
                          <option value="Mer">Mer</option>
                          <option value="Plage">Plage</option>
                          <option value="Paysage">Paysage</option>
                          <option value="Macro">Macro</option>
                          <option value="Portrait">Portrait</option>
                          <option value="Artistique">Artistique</option>
                          <option value="Volcan">Volcan</option>
                          <option value="Animaux">Animaux</option>
                          <option value="Lavande">Lavande</option>
                          <option value="Orage">Orage</option>
                        </select>
                        <select
                          onChange={(e) =>
                            handleChange(e.target.value, data.index, 2)
                          }
                          onClick={(event) => event.stopPropagation()}
                          defaultValue={data.tags[2]}
                        >
                          <option className="default-tag" value="">
                            Tag 3
                          </option>
                          <option value="Nuit">Nuit</option>
                          <option value="Coucher de soleil">
                            Coucher de soleil
                          </option>
                          <option value="Jours">Jours</option>
                          <option value="Levé du soleil">Levé du soleil</option>
                          <option value="Montagne">Montagne</option>
                          <option value="Ville">Ville</option>
                          <option value="Mer">Mer</option>
                          <option value="Plage">Plage</option>
                          <option value="Paysage">Paysage</option>
                          <option value="Macro">Macro</option>
                          <option value="Portrait">Portrait</option>
                          <option value="Artistique">Artistique</option>
                          <option value="Volcan">Volcan</option>
                          <option value="Animaux">Animaux</option>
                          <option value="Lavande">Lavande</option>
                          <option value="Orage">Orage</option>
                          <option value="Vue du ciel">Vue du ciel</option>
                        </select>
                        <input
                          onKeyUp={(e) =>
                            handleKeyUp(e, e.target.value, data.index, 3)
                          }
                          onClick={(event) => event.stopPropagation()}
                          placeholder="Tag 4"
                          defaultValue={data.tags[3]}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="ctn-button">
              <ButtonComponent
                text="Charger plus"
                onClick={() => handleClick()}
                state={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageImage;
